import React, { FC, ReactNode } from 'react';
import { Box, Text } from '@wix/design-system';
import s from './Button.scss';

export interface ButtonProps {
  onClick: () => void;
  label: string;
  icon?: ReactNode;
  className?: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  dataHook?: string;
  align?: 'start' | 'center';
}

export const Button: FC<ButtonProps> = ({
  onClick,
  label,
  icon,
  className = '',
  isSelected = false,
  isDisabled = false,
  dataHook,
  align = 'start',
}) => {
  return (
    <button
      onClick={onClick}
      className={`${s.button} ${isSelected ? s.selected : ''} ${isDisabled ? s.disabled : ''} ${className}`}
      data-hook={dataHook}
      disabled={isDisabled}
    >
      <Box
        direction="horizontal"
        verticalAlign="middle"
        gap={2}
        align={align === 'center' ? 'center' : undefined}
        width="100%"
      >
        {icon}
        <Text size="small">{label}</Text>
      </Box>
    </button>
  );
};
